import React, { useState, useEffect, useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import { recordTypes } from "../../../../API/config";
import { getCommentHistory } from "../../../../API/Entity";
import styles from "./styles";
import { NoAccessScreen, LoadingIndicator } from "../../../../Component";
import CommentsTable from "./CommentsTable";
import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import mime from "mime-types";
import { saveAs } from "file-saver";
import { httpGetF } from "../../../../API/Http";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../Component/CustomButton";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const Comments = (props) => {
  const { classes, entity, hasRecordPermission, open, onClose } = props;
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(open);
  const [isLoaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [canViewApprovalComments, setCanViewApprovalComments] = useState();
  const [kycComments, setKycComments] = useState([]);
  const [amlComments, setAmlComments] = useState([]);

  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    const setPermissions = async () => {
      const { permissions = {} } = entity;

      const canViewApprovalComments = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewScoreComments.name
      );

      setCanViewApprovalComments(canViewApprovalComments);

      setLoaded(true);
    };

    const loadCommentHistory = async () => {
      try {
        const result = await getCommentHistory(entity.id);
        const { data = [] } = result;
        setKycComments(data.filter((c) => c.check_type === "KYC"));
        setAmlComments(data.filter((c) => c.check_type === "AML"));
        setLoading(false);
      } catch (error) {
        setLoading(false);
        showErrorMessage({ error });
      }
    };

    setPermissions();
    loadCommentHistory();
  }, [entity]);

  if (isLoaded && !canViewApprovalComments) {
    return <NoAccessScreen />;
  }
  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const onRowDownloadClick = async (docEnt) => {
    setLoading(true);
    try {
      const response = await httpGetF("/entity/scoreApprovalDocument", {
        id: Number(docEnt.id),
      });
      const file = new Blob([response], { type: mime.lookup(docEnt.filename) });
      setLoading(false);
      saveAs(file, docEnt.filename);
    } catch (e) {
      setLoading(false);
      showErrorMessage({ message: t("messages.record.comments.couldNotFetchDocument") });
    }
  };

  const renderComments = () => {
    return (
      <div className={classes.pageContent}>
        <div className={classes.tableWrapper}>
          <div>
            <Typography
              className={classes.tableTitle}
            >{t("labels.record.comments.kycScoreComments")}</Typography>
          </div>

          <CommentsTable
            comments={kycComments}
            style={{ margin: 15 }}
            onRowDownloadClick={onRowDownloadClick}
          ></CommentsTable>
        </div>

        <div className={classes.tableWrapper}>
          <div>
            <Typography
              className={classes.tableTitle}
            >{t("labels.record.comments.amlScoreComments")}</Typography>
          </div>

          <CommentsTable
            comments={amlComments}
            style={{ margin: 15 }}
            onRowDownloadClick={onRowDownloadClick}
          ></CommentsTable>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        <Typography className={classes.panelTitle}>{t("labels.record.comments.commentsHistory")}</Typography>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? renderLoadingIndicator() : renderComments()}
      </DialogContent>
      <DialogActions>
        <CustomButton variant="secondary" isDisabled={loading} onClick={onClose}>
          {t("labels.common.cancel")}
        </CustomButton>

      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles, { withTheme: true })(Comments);
